<template>
  <div class="content-container">
    <div class="content-wrapper-sender">
      <h1>Создать рассылку</h1>

      <form v-if="showForm" method="POST" enctype="multipart/form-data">
        <!-- 🧩 Выбор ботов -->
        <div class="select-bot-container">
          <div class="bot-list-header">
            <span>Выберите ботов:</span>
            <button type="button" class="btn-select-all" @click="toggleSelectAll">
              {{ allSelected ? "Снять выделение" : "Выбрать всех" }}
            </button>
          </div>

          <div class="bot-checkboxes">
            <label
                v-for="bot in listBots"
                :key="bot.id"
                class="bot-checkbox-item"
                :class="{ selected: selectedBots.includes(bot.username) }"
            >
              <input type="checkbox" v-model="selectedBots" :value="bot.username" />
              <span>@{{ bot.username }}</span>
            </label>
          </div>

          <p v-if="selectedBots.length" class="selected-info">
            ✅ Выбрано: {{ selectedBots.join(", ") }}
          </p>
        </div>

        <!-- 📦 Контент рассылки -->
        <div class="select-bot-content">
          <div class="enter-message-form">
            <div v-for="(card, index) in cardsList" :key="index" class="card-block">
              <!-- 📝 текст -->
              <div v-if="card.type === 'Текст'" class="card-block-container">
                <div class="card-menu-content">
                  <!-- 🧰 Toolbar -->
                  <div class="toolbar">
                    <button @click.prevent="applyFormat(index, 'bold')"><b>B</b></button>
                    <button @click.prevent="applyFormat(index, 'italic')"><i>I</i></button>
                    <button @click.prevent="applyFormat(index, 'underline')"><u>U</u></button>
                    <button @click.prevent="insertLink(index)">🔗</button>
                  </div>

                  <!-- визуальный редактор -->
                  <div
                      class="editable"
                      contenteditable="true"
                      :ref="'editor-' + index"
                      @input="syncFromEditor(index)"
                      @blur="syncFromEditor(index)"
                      :placeholder="'Введите текст сообщения...'"
                  ></div>

                  <!-- скрытый textarea для подсчёта символов -->
                  <textarea
                      v-model="card.value"
                      class="hidden-textarea"
                      @input="updateText(index)"
                  ></textarea>

                  <div
                      class="remaining-chars"
                      :class="{ warn: card.remaining < 200, error: card.remaining < 0 }"
                  >
                    Символов: {{ card.jsLength || 0 }} / 1024
                    <span v-if="card.remaining < 0">
                      ❌ Превышен лимит на {{ Math.abs(card.remaining) }}
                    </span>
                  </div>

                  <!-- 🔘 кнопки -->
                  <div
                      class="form-buttons"
                      v-for="(button, bIndex) in card.buttons"
                      :key="bIndex"
                  >
                    <span>Кнопка {{ bIndex + 1 }}</span>
                    <input
                        class="form-buttons-text"
                        type="text"
                        placeholder="Текст"
                        v-model="button.text"
                    />
                    <input
                        class="form-buttons-text"
                        type="text"
                        placeholder="Ссылка"
                        v-model="button.link"
                    />
                  </div>

                  <button
                      @click="handleAddButton(index)"
                      type="button"
                      class="card-add-button"
                  >
                    + Добавить кнопку
                  </button>
                </div>

                <div class="card-menu-icons">
                  <button type="button" @click="moveCardUp(index)" v-if="index > 0">
                    <i class="bi bi-caret-up-fill"></i>
                  </button>
                  <button type="button" @click="moveCardDown(index)" v-if="index < cardsList.length - 1">
                    <i class="bi bi-caret-down-fill"></i>
                  </button>
                  <button type="button" @click="removeCard(index)">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>

              <!-- 🖼 изображение -->
              <div v-else-if="card.type === 'Изображение'" class="card-block-container">
                <div class="card-menu-content">
                  <div class="form-image">
                    <input
                        type="file"
                        :id="'imageInput-' + index"
                        style="display: none"
                        @change="onImageChange($event, index)"
                    />
                    <div class="image-preview">
                      <img v-if="card.imgPreview" :src="card.imgPreview" />
                    </div>
                    <button
                        v-if="!card.imgPreview"
                        type="button"
                        @click="openImageInput(index)"
                    >
                      Выберите изображение
                    </button>
                  </div>

                  <div
                      class="form-buttons"
                      v-for="(button, bIndex) in card.buttons"
                      :key="bIndex"
                  >
                    <span>Кнопка {{ bIndex + 1 }}</span>
                    <input
                        class="form-buttons-text"
                        type="text"
                        placeholder="Текст"
                        v-model="button.text"
                    />
                    <input
                        class="form-buttons-text"
                        type="text"
                        placeholder="Ссылка"
                        v-model="button.link"
                    />
                  </div>

                  <button
                      @click="handleAddButton(index)"
                      type="button"
                      class="card-add-button"
                  >
                    + Добавить кнопку
                  </button>
                </div>

                <div class="card-menu-icons">
                  <button type="button" @click="moveCardUp(index)" v-if="index > 0">
                    <i class="bi bi-caret-up-fill"></i>
                  </button>
                  <button type="button" @click="moveCardDown(index)" v-if="index < cardsList.length - 1">
                    <i class="bi bi-caret-down-fill"></i>
                  </button>
                  <button type="button" @click="removeCard(index)">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-add-element-btn-container">
              <button
                  type="button"
                  @click="showContentList = !showContentList"
                  class="form-add-element-btn"
              >
                Добавить... <i class="bi bi-caret-down-fill"></i>
              </button>
            </div>

            <div v-if="showContentList" class="form-card-types">
              <div
                  v-for="item in telegramContentTypes"
                  :key="item.type"
                  class="form-card-types-item"
              >
                <button type="button" @click="pushCardItem(item)">
                  {{ item.type }}
                </button>
              </div>
            </div>

            <div class="form-next">
              <button
                  class="form-next-btn"
                  type="button"
                  @click="sendPost"
                  :disabled="formInvalid"
              >
                🚀 Запустить рассылку
              </button>
            </div>
            <div v-if="formInvalid" class="form-errors">
              <p v-for="(err, i) in validationErrors" :key="i" class="error-line">
                ❌ {{ err }}
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { API_URL } from "@/config";
export default {
  name: "Sender",
  data() {
    return {
      showForm: true,
      listBots: [],
      selectedBots: [],
      allSelected: false,
      cardsList: [],
      telegramContentTypes: [{ type: "Текст" }, { type: "Изображение" }],
      showContentList: false,
    };
  },
  async created() {
    await this.loadListBots();
  },
  computed: {
    // проверка ссылок
    hasInvalidLinks() {
      return this.cardsList.some(card =>
          card.buttons.some(btn => btn.link && !this.isValidUrl(btn.link))
      );
    },

    // проверка текстовых карточек
    hasInvalidText() {
      return this.cardsList.some(card =>
              card.type === "Текст" && (
                  card.jsLength === 0 ||          // пустая
                  card.jsLength > 1024            // превышен лимит
              )
      );
    },
    hasEmptyButtons() {
      return this.cardsList.some(card =>
          card.buttons.some(btn =>
              !btn.text?.trim() || !btn.link?.trim()
          )
      );
    },
    // финальная валидация формы
    formInvalid() {
      return (
          this.selectedBots.length === 0 ||
          this.cardsList.length === 0 ||
          this.hasInvalidLinks ||
          this.hasInvalidText ||
          this.hasEmptyButtons    // ⬅ добавлено
      );
    },
    validationErrors() {
      const errors = [];

      if (this.selectedBots.length === 0) errors.push("Не выбран ни один бот");
      if (this.cardsList.length === 0)   errors.push("Не добавлено ни одного блока контента");
      if (this.hasInvalidLinks)          errors.push("Есть кнопки с неверной ссылкой");
      if (this.hasEmptyButtons)          errors.push("Есть кнопки без текста или без ссылки");
      if (this.hasInvalidText)           errors.push("Текстовые блоки пустые или превышают лимит 1024 символа");

      return errors;
    }
  },
  methods: {
    async loadListBots() {
      this.listBots = await fetch(`${API_URL}/bots`)
          .then((r) => r.json())
          .catch(() => []);
    },
    toggleSelectAll() {
      this.allSelected
          ? (this.selectedBots = [])
          : (this.selectedBots = this.listBots.map((b) => b.username));
      this.allSelected = !this.allSelected;
    },
    openImageInput(index) {
      document.getElementById(`imageInput-${index}`).click();
    },
    onImageChange(e, index) {
      const file = e.target.files[0];
      if (!file) return;
      this.cardsList[index].filename = file.name;
      const reader = new FileReader();
      reader.onloadend = () => {
        this.cardsList[index].imgPreview = reader.result;
        this.cardsList[index].value = reader.result.replace("data:", "").replace(/^.+,/, "");
      };
      reader.readAsDataURL(file);
    },
    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    },
    saveEditorsContent() {
      // Сохраняем HTML и текст перед перемещением
      this.cardsList.forEach((_, i) => {
        const ref = this.$refs["editor-" + i];
        if (ref && ref[0]) {
          const el = ref[0];
          this.cardsList[i].html = el.innerHTML;
          this.cardsList[i].value = el.innerText.trim();
        }
      });
    },

    restoreEditorsContent() {
      // После перемещения восстанавливаем содержимое
      this.$nextTick(() => {
        this.cardsList.forEach((card, i) => {
          const ref = this.$refs["editor-" + i];
          if (ref && ref[0]) {
            const el = ref[0];
            if (card.html) el.innerHTML = card.html;
          }
        });
      });
    },

    moveCardUp(i) {
      this.saveEditorsContent();
      if (i > 0) {
        const tmp = this.cardsList[i];
        this.cardsList.splice(i, 1);
        this.cardsList.splice(i - 1, 0, tmp);
      }
      this.restoreEditorsContent();
    },

    moveCardDown(i) {
      this.saveEditorsContent();
      if (i < this.cardsList.length - 1) {
        const tmp = this.cardsList[i];
        this.cardsList.splice(i, 1);
        this.cardsList.splice(i + 1, 0, tmp);
      }
      this.restoreEditorsContent();
    },
    removeCard(i) {
      this.cardsList.splice(i, 1);
    },
    handleAddButton(i) {
      this.cardsList[i].buttons.push({ text: "", link: "" });
    },
    pushCardItem(item) {
      this.cardsList.push({
        type: item.type,
        value: "",
        html: "",
        buttons: [],
        filename: "",
        imgPreview: "",
        jsLength: 0,
        remaining: 1024,
      });
    },
    applyFormat(index, cmd) {
      const editor = this.$refs["editor-" + index][0];
      editor.focus();
      document.execCommand(cmd, false, null);
      this.syncFromEditor(index);
    },
    insertLink(index) {
      const url = prompt("Введите ссылку:");
      if (!url) return;
      const editor = this.$refs["editor-" + index][0];
      editor.focus();
      document.execCommand("createLink", false, url);
      this.syncFromEditor(index);
    },
    syncFromEditor(index) {
      const editor = this.$refs["editor-" + index][0];
      const visibleText = editor.innerText.replace(/\r\n|\r/g, "\n").trim();
      this.cardsList[index].value = visibleText;
      this.cardsList[index].html = editor.innerHTML;
      this.updateText(index);
    },
    updateText(index) {
      const clean = (this.cardsList[index].value || "").trim();
      this.cardsList[index].jsLength = clean.length;
      this.cardsList[index].remaining = 1024 - clean.length;
    },
    cleanHtmlForTelegram(html) {
      let cleaned = html;

      // Удаляем мусорные div/p/span
      cleaned = cleaned
          .replace(/<div[^>]*>/g, "\n")
          .replace(/<\/div>/g, "")
          .replace(/<p[^>]*>/g, "\n")
          .replace(/<\/p>/g, "")
          .replace(/<span[^>]*>/g, "")
          .replace(/<\/span>/g, "");

      // Убираем <br> → перенос строки
      cleaned = cleaned.replace(/<br[^>]*>/g, "\n");

      // Удаляем неизвестные теги, оставляем только: b, strong, i, em, u, s, a
      cleaned = cleaned.replace(
          /<(?!\/?(b|strong|i|em|u|s|a)(\s|>|\/))/gi,
          ""
      );

      // Удаляем атрибуты у всех тегов, кроме <a href="">
      cleaned = cleaned.replace(/<(?!a\b)([a-z]+)\s+[^>]*>/gi, "<$1>");

      // Убираем вложенные кривые bold
      cleaned = cleaned.replace(/<b><b>/g, "<b>");
      cleaned = cleaned.replace(/<\/b><\/b>/g, "</b>");

      // Убираем пустые bold
      cleaned = cleaned.replace(/<b>\s*<\/b>/g, "");

      // красивый trim
      cleaned = cleaned.replace(/\n{3,}/g, "\n\n");

      return cleaned.trim();
    },
    async sendPost() {
      const payload = this.cardsList.map((c) =>
          c.type === "Текст"
              ? { ...c, value: this.cleanHtmlForTelegram(c.html) }
              : c
      );
      console.log(payload);
      await fetch(`${API_URL}/sender`, {
        method: "POST",
        headers: { "Content-Type": "application/json;charset=utf-8" },
        body: JSON.stringify({ bots: this.selectedBots, cards: payload }),
      });
      this.$router.push("/broadcast_status");
    },
  },
};
</script>

<style scoped>
.bot-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.bot-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 10px;
}

.bot-checkbox-item {
  background: #f7f9fc;
  border: 1px solid #dce3ec;
  border-radius: 8px;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bot-checkbox-item:hover {
  background: #eef3fa;
  border-color: #c2d3eb;
}

.bot-checkbox-item input[type="checkbox"] {
  accent-color: #2ecc71; /* зелёная галочка */
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.bot-checkbox-item span {
  font-size: 14px;
  color: #333;
}

.bot-checkbox-item.selected {
  background: #e8f6ee;
  border-color: #2ecc71;
  box-shadow: 0 0 5px rgba(46, 204, 113, 0.3);
}

.btn-select-all {
  background: #2ecc71;
  border: none;
  color: white;
  font-size: 14px;
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-select-all:hover {
  background: #27ae60;
}

.selected-info {
  margin-top: 8px;
  font-size: 13px;
  color: #555;
}

.toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}
.toolbar button {
  background: #f7f9fc;
  border: 1px solid #d5dce5;
  padding: 4px 10px;
  border-radius: 5px;
}

.toolbar button:hover {
  background: #eef3fa;
  border-color: #c3d1e3;
}
.remaining-chars {
  font-size: 12px;
  color: #777;
  margin-top: 5px;
}
.remaining-chars.warn {
  color: #e67e22;
}
.remaining-chars.error {
  color: #e74c3c;
  font-weight: 600;
}

.hidden-textarea {
  display: none;
}

.editable {
  min-height: 150px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  line-height: 1.4;
  resize: vertical;
  background: #fff;
  outline: none;
  white-space: pre-wrap;
}

.editable a {
  color: #2980b9;
  text-decoration: underline;
}

.editable:empty:before {
  content: attr(placeholder);
  color: #aaa;
}

.card-menu-icons {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.card-menu-icons button {
  background: #f7f9fc;
  border: 1px solid #d5dce5;
  padding: 6px;
  border-radius: 6px;
  margin-bottom: 5px;
}

.card-menu-icons button:hover {
  background: #eef3fa;
  border-color: #c3d1e3;
}

.card-menu-icons i {
  font-size: 16px;
  color: #444;
}

.form-image button {
  background: #f2f4f7;
  border: 1px solid #d5dce5;
  padding: 10px 14px;
  border-radius: 6px;
  color: #333;
}

.form-image button:hover {
  background: #e3e6eb;
}

.form-card-types-item button {
  background: #fff;
  border: 1px solid #d5dce5;
  padding: 8px 14px;
  width: 100%;
  text-align: left;
  border-radius: 6px;
}

.form-card-types-item button:hover {
  background: #f0f4fa;
  border-color: #c3d1e3;
}

.form-next-btn:disabled {
  background: #bfc7cc !important;
  cursor: not-allowed !important;
  opacity: 0.6;
  box-shadow: none;
  border: 1px solid #959ea5;
}

.form-errors {
  margin-top: 10px;
  background: #ffe9e9;
  padding: 10px 14px;
  border-left: 3px solid #e74c3c;
  border-radius: 6px;
}

.error-line {
  margin: 2px 0;
  font-size: 14px;
  color: #c0392b;
}
</style>
